import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Toast,
  ToastService,
  ToastType,
} from '../../../../services/toast/toast.service';

@Component({
  selector: 'app-toast-container',
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.css',
})
export class ToastContainerComponent {
  // No manual subscription: the template reads this directly via the async pipe.
  readonly toasts$: Observable<Toast[]>;

  constructor(private toastService: ToastService) {
    this.toasts$ = this.toastService.toasts$;
  }

  close(id: number): void {
    this.toastService.remove(id);
  }

  getTitle(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'Operazione completata';
      case 'error':
        return 'Errore';
      case 'warning':
        return 'Attenzione';
      case 'info':
        return 'Informazione';
    }
  }
}
